import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";

const deleteRestrictedFieldModalProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({
        fieldKey: PropTypes.number,
        fieldName: PropTypes.string,
        deleteField: PropTypes.func.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type DeleteRestrictedFieldModalProps = PropTypes.InferProps<typeof deleteRestrictedFieldModalProps>;

const DeleteRestrictedFieldModal: React.FC<DeleteRestrictedFieldModalProps> = ({
    modalProps,
    isOpen,
}: DeleteRestrictedFieldModalProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("DELETE_RESTRICTED_FIELD"));

    const deleteFieldRequest = () => {
        modalProps.deleteField(modalProps.fieldKey);
        hide();
    };

    return (
        <MaterialModal
            title="Delete Field"
            isOpen={isOpen}
            onClose={() => hide()}
            id="flow-delete"
            maxWidth="lg"
            primaryButtonText="Delete"
            onPrimaryButtonRequest={() => deleteFieldRequest()}
        >
            <div>
                <span style={{ fontSize: "18px" }}>
                    Confirm removal of <strong className="text-danger">{modalProps.fieldName}</strong> from the
                    restricted list
                </span>
            </div>
        </MaterialModal>
    );
};

export default withModal(DeleteRestrictedFieldModal, "DELETE_RESTRICTED_FIELD");
